import { useCallback, useState } from 'react';

export function useDisclosure(isOpenDefault = false) {
  const [isOpen, setIsOpen] = useState(isOpenDefault);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((state) => !state), []);

  return { isOpen, open, close, toggle };
}


export function useDisclosureWithOpts(isOpenDefault = false) {
  const [data, setData] = useState({ isOpen: isOpenDefault, opts: {} });

  const open = useCallback((opts) => setData({ isOpen: true, opts: opts ?? data.opts }), []);
  const close = useCallback(() => setData({ isOpen: false, opts: {} }), []);

  return { isOpen: data.isOpen, open, close, opts: data.opts };
}